import {
  ECONOMY_UNITS,
  ECONOMY_UNITS_VALUES,
} from "../pages/admin-details/account/constants";

export const convertFuelEconomy = (to: ECONOMY_UNITS, value: number) => {
  switch (to) {
    case ECONOMY_UNITS.KML:
      return value;
    case ECONOMY_UNITS.MPG:
      return value * 2.3521458;
    case ECONOMY_UNITS.KPG:
      return value * 3.78541178;
    case ECONOMY_UNITS.L_100KM:
      return value !== 0 ? 100 / value : Infinity;
    default:
      return value;
  }
};
export const convertToKmlForApi = (from: ECONOMY_UNITS, value: number) => {
  switch (from) {
    case ECONOMY_UNITS.KML:
      return value;
    case ECONOMY_UNITS.MPG:
      return value / 2.3521458;
    case ECONOMY_UNITS.KPG:
      return value / 3.78541178;
    case ECONOMY_UNITS.L_100KM:
      return value !== 0 ? 100 / value : Infinity;
    default:
      return value;
  }
};
